import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'

import { Button, ListItem, makeStyles, Typography, useTheme } from '@material-ui/core'

import useViewportSize from '~/components/useViewportSize'
import { useLiterals } from '~/components/Literals'

import ifood from '~/assets/ifood-43.svg'
import { clickIfood } from '~/track'

const selector = createSelector(
  (state) => state.config,
  (state) => state.app.currentProduct,
  (state) => state.position,
  (...args) => args
)

const useStyles = makeStyles(() => ({
  root: {
    padding: '24px 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    margin: 8,
    borderRadius: 4,
    width: 'auto'
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#EA1D2C',
    width: 100,
    height: 40,
    '&:hover': {
      backgroundColor: '#EA1D2C'
    }
  }
}))

function IfoodBanner({ url }) {
  const [config, currentProduct, position] = useSelector(selector)

  const viewport = useViewportSize()
  const theme = useTheme()
  const isMobile = viewport.width < theme.gofind.desktopMaxWidth
  const classes = useStyles({ isMobile })
  const { getLiteral } = useLiterals()

  const handleClickIfood = useCallback(() => {
    if (position.user) {
      clickIfood(config, currentProduct, position.user)
    }
  }, [config, currentProduct, position])

  return (
    <ListItem className={classes.root} key={url}>
      <Typography variant="body1">{getLiteral('2600')}</Typography>
      <Button
        disableRipple
        variant="contained"
        target="_blank"
        href={url}
        onClick={handleClickIfood}
        className={classes.button}
      >
        <img src={ifood} alt="Logo iFodd" width="40" height="40" />
      </Button>
    </ListItem>
  )
}

export default IfoodBanner
